export default __webpack_public_path__ + "static/media/icon_recommend-product-hover.55c74e8d.png";